<div class="district-container pt-20">
  <div class="cardList">
    <ng-container>
      <mat-card class="cardListItem small-height box-shadow">
        <mat-card-header>
          <mat-card-title>{{headingTitle}}</mat-card-title>
        </mat-card-header>
        <mat-card-content><span *ngIf="disclaimer" class="disclaimer">{{disclaimer}}</span></mat-card-content>
      </mat-card>
      <mat-card
        *ngIf="electionService.isMobile === false"
        class="cardListItem small-height box-shadow"
      >
        <mat-card-header>
          <mat-card-title>Last updated</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <h2>{{ lastUpdate | date : "dd MMM yyyy HH:mm" }}</h2>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </div>
  <div class="cardList">
    <ng-container *ngIf="!isMobile; else mobile">
      <!-- Component 3  -->
      <mat-card class="cardListItem">
        <mat-card-header>
          <mat-card-title>Votes won</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <lc-votes-won-graph
            [chartTitle]="'Votes won'"
            [chartSubTitle]="''"
          ></lc-votes-won-graph>
        </mat-card-content>
      </mat-card>
      <!-- Component 5 - Count progress -->
      <mat-card *ngIf="!isFinal" class="cardListItem">
        <mat-card-header>
          <mat-card-title>Count progress</mat-card-title>
          <mat-card-subtitle>Counting for the Legislative Council takes longer than the House of Assembly because of the complex nature of the counting system used. Counts can take several weeks. For more information, see <a href="https://www.ecsa.sa.gov.au/?view=article&id=38:counting-the-votes-for-the-legislative-council" target="_blank" rel="noopener noreferrer">The Legislative Council count process</a>.</mat-card-subtitle>
        </mat-card-header>
        <lc-count-progress-table></lc-count-progress-table>
        <div style="height: 30px"></div>
      </mat-card>
      <!-- Component 6  -->
      <mat-card *ngIf="isFinal" class="cardListItem">
        <app-lc-hemicycle-graph></app-lc-hemicycle-graph>
      </mat-card>
      <!-- Component 4  -->
      <mat-card class="cardListItem">
        <mat-card-header>
          <mat-card-title>Votes won</mat-card-title>
        </mat-card-header>
        <lc-votes-won-table></lc-votes-won-table>
      </mat-card>
      <!-- Component 7  -->
      <mat-card class="cardListItem">
        <lc-quota-won-table></lc-quota-won-table>
      </mat-card>
      <!-- Component 8  -->
      <mat-card class="cardListItem full-width">
        <mat-card-header>
          <mat-card-title>Essential statistics</mat-card-title>
        </mat-card-header>
        <lc-turnout-by-district></lc-turnout-by-district>
      </mat-card>
      <!-- Component 9  -->
      <ng-container *ngIf="isFinal">
        <mat-card class="cardListItem full-width">
          <app-lc-candidate-elected-table></app-lc-candidate-elected-table>
        </mat-card>
      </ng-container>
    </ng-container>

    <!-- Mobile View -->

    <ng-template #mobile>
      <!-- Component 3  -->
      <mat-card class="cardListItem">
        <mat-card-header>
          <mat-card-title>Votes won</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <lc-votes-won-graph
            [chartTitle]="'Votes won'"
            [chartSubTitle]="''"
          ></lc-votes-won-graph>
        </mat-card-content>
      </mat-card>
      <!-- Component 4  -->
      <mat-card class="cardListItem">
        <mat-card-header>
          <mat-card-title>Votes won</mat-card-title>
        </mat-card-header>
        <lc-votes-won-table></lc-votes-won-table>
      </mat-card>
      <!-- Component 5 - Count progress -->
      <mat-card *ngIf="!isFinal" class="cardListItem">
        <mat-card-header>
          <mat-card-title>Count progress</mat-card-title>
          <mat-card-subtitle>Counting for the Legislative Council takes longer than the House of Assembly because of the complex nature of the counting system used. Counts can take several weeks. For more information, see <a href="https://www.ecsa.sa.gov.au/?view=article&id=38:counting-the-votes-for-the-legislative-council" target="_blank" rel="noopener noreferrer">The Legislative Council count process</a>.</mat-card-subtitle>
        </mat-card-header>
        <lc-count-progress-table></lc-count-progress-table>
        <div style="height: 30px"></div>
      </mat-card>
      <!-- Component 6  -->
      <mat-card *ngIf="isFinal" class="cardListItem">
        <app-lc-hemicycle-graph></app-lc-hemicycle-graph>
      </mat-card>
      <!-- Component 7  -->
      <mat-card class="cardListItem">
        <lc-quota-won-table></lc-quota-won-table>
      </mat-card>
      <!-- Component 8  -->
      <mat-card class="cardListItem full-width">
        <mat-card-header>
          <mat-card-title>Essential statistics</mat-card-title>
        </mat-card-header>
        <lc-turnout-by-district></lc-turnout-by-district>
      </mat-card>
      <!-- Component 9  -->
      <ng-container *ngIf="isFinal">
        <mat-card class="cardListItem full-width">
          <app-lc-candidate-elected-table></app-lc-candidate-elected-table>
        </mat-card>
      </ng-container>
    </ng-template>
  </div>

  <!-- Editable Content Area -->
  <app-editable-content [content]="editableContent"></app-editable-content>
</div>
